import "clsx";
function _page($$payload) {
  $$payload.out.push(`<h1>Home page</h1>`);
}
export {
  _page as default
};
